import React, {Dispatch, SetStateAction, useCallback} from 'react';
import {Icon} from 'shared/helpers';
import styled, {useTheme} from 'styled-components';
import {FormControl} from 'react-bootstrap';
import {ItemType} from 'shared/components/Product/Item';

interface NumberSpinnerProps {
    quantity?: number;
    setQuantity?: Dispatch<SetStateAction<number>>;
    item?: ItemType;
}

export const NumberSpinner = ({
    quantity,
    setQuantity,
    item,
}: NumberSpinnerProps) => {
    const theme = useTheme();

    const changeHandler = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = parseInt(event.target.value);
            if (setQuantity) {
                setQuantity(newValue);
            }
        },
        [setQuantity]
    );

    const decrement = useCallback(() => {
        if (setQuantity) {
            setQuantity((quantity) => {
                if (quantity > 1) {
                    return quantity - 1;
                }

                return quantity;
            });
        }
    }, [setQuantity]);

    const increment = useCallback(() => {
        if (setQuantity) {
            setQuantity((quantity) => {
                return quantity + 1;
            });
        }
    }, [setQuantity]);

    return (
        <Container>
            <Buttons
                data-cy="decrement-button"
                iconName="Button-Minus.svg"
                color={theme.colors.secondary?.main}
                onClick={decrement}
            />
            <Number
                data-cy={item ? `quantity-${item.id}` : 'quantity'}
                type="number"
                value={quantity}
                min={1}
                max={9999}
                required
                onChange={changeHandler}
            />
            <Buttons
                data-cy="increment-button"
                iconName="Button-Plus.svg"
                color={theme.colors.secondary?.main}
                onClick={increment}
            />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    gap: 5px;
`;

const Buttons = styled((props) => <Icon {...props} />)`
    width: 15px;
    cursor: pointer;
`;

export const Number = styled(FormControl)<{$width?: number}>`
    border: 2px solid ${({theme}) => theme.colors.primary?.main};
    border-radius: 10px;
    padding: 0 5px;
    height: 30px;
    font-size: 0.9em;
    text-align: center;
    min-width: ${({$width = 25}) => `${$width}px`};

    :focus,
    :active {
        border-color: ${({theme}) => theme.colors.secondary?.main};
    }
`;
